function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4598 8.69904C19.4593 8.69858 19.4589 8.69812 19.4584 8.69766L11.3 0.539551C10.9523 0.19165 10.4899 0 9.99813 0C9.50634 0 9.044 0.191498 8.6961 0.539398L0.541952 8.69339C0.539205 8.69614 0.536458 8.69904 0.533712 8.70178C-0.180399 9.42001 -0.179179 10.5853 0.537221 11.3017C0.864522 11.6292 1.2968 11.8188 1.75899 11.8387C1.77776 11.8405 1.79668 11.8414 1.81576 11.8414H2.14092V17.8453C2.14092 19.0334 3.10756 20 4.29592 20H7.48775C7.81124 20 8.07369 19.7377 8.07369 19.4141V14.707C8.07369 14.1649 8.51467 13.7239 9.05681 13.7239H10.9394C11.4816 13.7239 11.9226 14.1649 11.9226 14.707V19.4141C11.9226 19.7377 12.1849 20 12.5085 20H15.7003C16.8887 20 17.8553 19.0334 17.8553 17.8453V11.8414H18.1569C18.6485 11.8414 19.1108 11.6499 19.4589 11.302C20.176 10.5844 20.1764 9.41711 19.4598 8.69904Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "transparent"
})));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.924a2044.svg";
export { ForwardRef as ReactComponent };